import "./App.css";

import List from "./List";

export function App() {
  if (window.location.port == "1234") {
    document.getElementById("favicon").setAttribute("href", "chess.ico");

    /*
    console.log("Changing favicon");
    var olink = document.getElementById("favicon");
    if (olink) {
      document.head.removeChild(olink);
    }
    var link = document.createElement("link");
    link.id = "favicon";
    link.rel = "shortcut icon";
    link.href = "chess.ico";
    document.head.appendChild(link);
    */
  }

  return (
    <>
      <List id="List"></List>
    </>
  );
}
